import { useParams } from 'react-router-dom';
import ThemeTopicListSearch from '../components/ThemeTopicListSearch';
import ThematicNotFound from '../components/ThematicNotFound';
import { getTopicsByTheme, themes } from '../data';
import { getTopicsSearchIndex } from '../search';

export default function ThemeTopicsPage() {
    const { themeSlug } = useParams<{ themeSlug: string }>();
    const theme = themes.find((candidate) => candidate.slug === themeSlug);

    if (!theme || !themeSlug) {
        return (
            <ThematicNotFound
                title="Theme not found"
                message="The requested theme does not exist. Please return to Thematic Studies."
            />
        );
    }

    const topics = getTopicsByTheme(theme.id);
    const fullIndex = getTopicsSearchIndex();
    const searchEntries = fullIndex.filter((entry) => entry.themeSlug === themeSlug);

    return (
        <ThemeTopicListSearch
            themeSlug={themeSlug}
            themeName={theme.name}
            themeDescription={theme.detailedDescription}
            topics={topics}
            searchEntries={searchEntries}
        />
    );
}
